import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import DialogModal from '../utils/DialogModal';


export interface ExitDialogProps {
  open: boolean;
  onClose: (value?: string) => void;
}

const ExitDialog = (props: ExitDialogProps) => {

  const liveStreamRunning = useSelector((state: any) => state.layout.liveStreamRunning);

  const { open, onClose, ...other } = props;

  return (
    <DialogModal open={open} onClose={onClose} iconClass={"exclam"} buttonCancel={"CANCEL"} buttonOk={"YES, EXIT STUDIO"}>
      <>
          { liveStreamRunning ?
            <p>You’re about to exit BlueJeans Studio! This will end your current broadcast and your event will not be recorded.
            <br/><br/>
            Are you sure you want to exit?</p>
            :
            <p>Are you sure you want to exit your Studio Dashboard?</p>
          }
      </>
    </DialogModal>
  )
}

export default ExitDialog;

